import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import {
  bibShape,
  userIdentityShape,
  ugcContentAdvisoryShape,
  ugcAgeSuitabilityShape
} from '@bibliocommons/bc-prop-types';

import shelfItemShape from 'app/shapes/shelves/shelfItemShape';
import DisplayHeading from '../../../shared/UGC/DisplayHeading';
import ContentAdvisoryInfo from '../ContentAdvisoryInfo';
import AgeSuitabilityInfo from '../AgeSuitabilityInfo';

import './SuitabilityInfo.scss';

export class ShelfListItemSuitabilityInfo extends React.PureComponent {
  isSuitabilityExisting() {
    const { ownerAgeSuitabilityForBib, ownerContentAdvisoriesForBib } = this.props;
    return ownerAgeSuitabilityForBib || (ownerContentAdvisoriesForBib && ownerContentAdvisoriesForBib.size > 0);
  }

  renderContentAdvisoryInfo() {
    const {
      bib,
      item,
      owner,
      ownerContentAdvisoriesForBib,
      contentAdvisoriesActions,
      contentAdvisoriesTransactions,
      shelfActions,
      shelfTransactions
    } = this.props;

    return (
      <ContentAdvisoryInfo
        bib={bib}
        item={item}
        owner={owner}
        ownerContentAdvisoriesForBib={ownerContentAdvisoriesForBib}
        contentAdvisoriesActions={contentAdvisoriesActions}
        contentAdvisoriesTransactions={contentAdvisoriesTransactions}
        shelfActions={shelfActions}
        shelfTransactions={shelfTransactions}
      />
    );
  }

  renderAgeSuitabilityInfo() {
    const {
      bib,
      item,
      owner,
      ownerAgeSuitabilityForBib,
      ageSuitabilitiesActions,
      ageSuitabilitiesTransactions,
      shelfActions,
      shelfTransactions
    } = this.props;

    return (
      <AgeSuitabilityInfo
        bib={bib}
        item={item}
        owner={owner}
        ownerAgeSuitabilityForBib={ownerAgeSuitabilityForBib}
        ageSuitabilitiesActions={ageSuitabilitiesActions}
        ageSuitabilitiesTransactions={ageSuitabilitiesTransactions}
        shelfActions={shelfActions}
        shelfTransactions={shelfTransactions}
      />
    );
  }

  render() {
    if (this.isSuitabilityExisting()) {
      return (
        <div className="cp-shelf-list-item-suitability-info">
          <DisplayHeading>
            <FormattedMessage id="suitability" />
          </DisplayHeading>
          {this.renderAgeSuitabilityInfo()}
          {this.renderContentAdvisoryInfo()}
        </div>
      );
    }

    return null;
  }
}

ShelfListItemSuitabilityInfo.propTypes = {
  bib: bibShape.isRequired,
  owner: userIdentityShape.isRequired,
  item: shelfItemShape.isRequired,
  ownerContentAdvisoriesForBib: ImmutablePropTypes.listOf(ugcContentAdvisoryShape),
  ownerAgeSuitabilityForBib: ugcAgeSuitabilityShape,
  contentAdvisoriesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ageSuitabilitiesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  contentAdvisoriesTransactions: ImmutablePropTypes.map.isRequired,
  ageSuitabilitiesTransactions: ImmutablePropTypes.map.isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired
};

export default ShelfListItemSuitabilityInfo;
